//별별책방 - 본사 - 콘텐츠별 사용량 리스트
import React, { Component } from "react";

import AgGridReactEx from "@app/components/AgGridReactEx";
export default class MainContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            tableData: null,
            keyword: null,
        };
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState(
            {
                data: nextProps.data,
            },
            () => {
                this.setState({ tableData: this.listSearch(this.state.keyword) });
            }
        );
    };

    defaultColDef = {
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 60,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
    };

    listColumn = [
        {
            headerName: "no",
            field: "no",
            width: 45,
            minWidth: 45,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "콘텐츠명",
            field: "activityName",
            width: 200,
            minWidth: 140,
        },
        {
            headerName: "구분",
            field: "division",
            width: 120,
            minWidth: 80,
            cellRenderer: (param) => {
                if(param.value == "subject") return "주제별"
                else if(param.value == "nuri") return "누리"
                else if(param.value == "my_image") return "이미지"
                else if(param.value == "collabo") return "협동 그림"
                else if(param.value == "coding") return "코딩"
                else if(param.value == "my_youtube") return "유튜브"
            },
        },
        {
            headerName: "카테고리",
            field: "categoryName",
            width: 130,
            minWidth: 80,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "누리";
            },
        },
        {
            headerName: "실행수",
            field: "playCount",
            width: 120,
            minWidth: 50,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "누적 실행수",
            field: "playCountSum",
            width: 120,
            minWidth: 95,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];

    listSearch = (keyword) => {
        var list = this.state.data;
        var tableData = [];
        if (!keyword) {
            tableData = list;
        } else {
            list.map((item) => {
                if (item.nurseryName && item.nurseryName.indexOf(keyword) >= 0) {
                    tableData.push(item);
                }
            });
        }
        return tableData;
    };

    render() {
        if (this.state.tableData == null) {
            return (
                <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <span className="dashboard-spinner spinner-lg"></span>
                </div>
            );
        } else {
            return <AgGridReactEx height="235" defaultColDef={this.defaultColDef} columnDefs={this.listColumn} rowData={this.state.tableData} pagination={false} />;
        }
    }
}
